import React from 'react';
import styled, { css } from 'styled-components';
import Dot from '../../../Atoms/Dot';
import { P3 } from '../../../Atoms/Typo';

const Component = styled.div<{
  $status:
    | 'all'
    | 'return'
    | 'new'
    | 'all_future'
    | 'return_future'
    | 'new_future';
}>`
  display: flex;
  align-items: center;

  .voda_default_dot {
    ${(props) => {
      switch (props.$status) {
        case 'all':
          return css`
            background-color: ${props.theme.colors.purple4};
          `;
        case 'return':
          return css`
            background-color: ${props.theme.colors.green4};
          `;
        case 'new':
          return css`
            background-color: ${props.theme.colors.orange4};
          `;
        case 'all_future':
          return css`
            background-color: ${props.theme.colors.grey400};
          `;
        case 'return_future':
          return css`
            border: solid 1px ${props.theme.colors.green4};
            background-color: ${props.theme.colors.green1};
          `;
        case 'new_future':
          return css`
            border: solid 1px ${props.theme.colors.orange4};
            background-color: ${props.theme.colors.orange1};
          `;

        default:
          return css``;
      }
    }}
  }
`;

const Title = styled.div`
  ${P3}
  color: ${(props) => props.theme.colors.grey500};
  margin-left: 4px;
`;

interface LegendTitleProps {
  title?: string;
  status?:
    | 'all'
    | 'return'
    | 'new'
    | 'all_future'
    | 'return_future'
    | 'new_future';
}

const LegendTitleAllUser = ({ title, status = 'all' }: LegendTitleProps) => {
  return (
    <Component $status={status} className="voda_legend_title">
      <Dot />
      <Title>{title}</Title>
    </Component>
  );
};

export default LegendTitleAllUser;
